import { useNavigate } from 'react-router-dom';
import GenericForm from '../components/GenericForm';
import { add_beneficiary } from '../api/beneficiary_api';
import { isValidIsraeliID, isOnlyNumbers, isValidPhoneNumber, isValidEmail, isValidPassport  } from '../utils/validationId';

const AddBeneficiary = () => {
    const navigate = useNavigate();

    const handleSubmit = async (data) => {
        const idValue = data.donor_id || data.id || data.donorId;
        const type = data.id_type;

        if (type === 'tz') {
            if (!idValue || !isOnlyNumbers(idValue) || !isValidIsraeliID(idValue)) {
                alert("מספר ת.ז. לא תקין");
                return;
            }
        } else if (type === 'passport') {
            if (!idValue || !isValidPassport(idValue)) {
                alert("מספר דרכון לא תקין");
                return;
            }
        }

        if (data.phone && !isValidPhoneNumber(data.phone)) {
            alert("מספר פלאפון לא תקין");
            return;
        }
        if (data.teacher_phone && !isValidPhoneNumber(data.teacher_phone)) {
            alert("מס פלאפון מורה מקשרת לא תקין");
            return;
        }
        if (data.email && !isValidEmail(data.email)) {
            alert("אימייל לא תקין");
            return;
        }

        try {
            await add_beneficiary(data);
            alert('נוסף בהצלחה!');
            navigate('/beneficiaries');
        } catch (err) {
            if (err.status === 409 || (err.response && err.response.status === 409)) {
                if (data.id_type === 'passport') {
                    alert('מספר דרכון כבר קיים במערכת');
                } else {
                    alert('מספר ת.ז. כבר קיים במערכת');
                }
            } else {
                // שגיאות כלליות אחרות
                alert('הוספה נכשלה: ' + (err.response?.data?.message || 'שגיאת שרת'));
            }
        }
    };

    return (
        <>
        {/* <button className="home-btn" onClick={() => navigate('/main_screen')} style={{ marginTop: "2%", marginRight: "3%" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2">
                    <path d="M12 3L2 12h3v7h4v-5h6v5h4v-7h3L12 3z" />
                </svg>
            </button>
            <button className="home-btn" onClick={() => navigate('/beneficiaries')}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
            </button> */}
            <div className="top-buttons-container">
                {/* כפתור חזרה דף אחורה - עם חץ */}
                <button className="round-nav-btn" onClick={() => navigate(-1)} title="חזרה">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                </button>
                {/* כפתור דף הבית - עם בית */}
                <button className="round-nav-btn" onClick={() => navigate('/main_screen')} title="דף הבית">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2">
                        <path d="M12 3L2 12h3v7h4v-5h6v5h4v-7h3L12 3z" />
                    </svg>
                </button>
            </div>
            <h2 style={{ color: "#150F6B", textAlign: "center" }}>הוספת שם</h2>
            <GenericForm kind="student" mode="add" onSubmit={handleSubmit} />
        </>
    );
};

export default AddBeneficiary;